import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/entity-pages/subpage/about-us/src/components/gallery-preview/assets/video-photo-upload.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')